import React from 'react';

const widthContentOnly = {
  width: '1px',
};

const ColGroup = () => (
  <colgroup>
    <col style={widthContentOnly} />
    <col span={6} />
    <col style={widthContentOnly} />
  </colgroup>
);

export default ColGroup;
